'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import breakpoint from '../../utils/responsiveBreakpoints';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HighlightedProductsHeaderConfig } from '../../constants/HighlightedProductsHeaderConfig';
const SelectorButton = styled.button.withConfig({
  displayName: "MobileProductLevelSelector__SelectorButton",
  componentId: "sc-1t0s7xn-0"
})(["font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:#fff;flex-grow:1;flex-basis:33%;border:1px solid #7fd1de;transition:background-color 0.3s;&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}", ""], breakpoint.phoneLarge(_t || (_t = _`
    &:first-child {
      margin-bottom: -1px;
      margin-right: 0;
      border-radius: 3px 3px 0 0;
    }
    &:last-child {
      margin-top: -1px;
      margin-left: 0;
      border-radius: 0 0 3px 3px;
    }
  `)));
const SelectorButtonWrapper = styled.div.withConfig({
  displayName: "MobileProductLevelSelector__SelectorButtonWrapper",
  componentId: "sc-1t0s7xn-1"
})(["display:flex;width:80%;margin:0 auto;", ""], breakpoint.phoneLarge(_t2 || (_t2 = _`
    flex-direction: column;
  `)));

const MobileSelectorButton = ({
  productLevel,
  productLine,
  onClick,
  active
}) => {
  return /*#__PURE__*/_jsx(SelectorButton, {
    onClick: onClick,
    className: active ? 'active' : '',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: HighlightedProductsHeaderConfig[productLine][productLevel].title
    })
  });
};

const MobileProductLevelSelector = ({
  productLevels,
  productLine,
  onClick,
  selectedProductLevel
}) => {
  return /*#__PURE__*/_jsx(SelectorButtonWrapper, {
    children: productLevels.map(productLevel => /*#__PURE__*/_jsx(MobileSelectorButton, {
      productLevel: productLevel,
      productLine: productLine,
      onClick: () => onClick(productLevel),
      active: selectedProductLevel === productLevel
    }, productLevel))
  });
};

export default MobileProductLevelSelector;